import React from "react";

import AboutPageContent from "../components/aboutPageContent";

const About = () => {
  return <AboutPageContent />;
};

export default About;
